
//pageType{0:'进展中的工作',1:'已完成的工作',2:'我的工作申请中的工作',3:'我的工作已完成的工作',4:'我的工作审批过的工作',5:'工作审批',6:'我的工作已关注的工作'}
export const wchService = {
    getWorkflowHeader ( type ){
        return this['headerFor' + type];
    },
    //公共的头
    ordinaryHeader: [
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '执行结果', field: 'wf_result' }
    ],
    //操作列
    headerFor0: [
        { headerName: '操作', width: 120,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: false,minWidth: 50,cellRenderer: (param)=>{
            let cancel = '<a href=javascript:void(0); class="ui-link" data-type="cancel">取消</a>'
            if(Object.is(wchService.permission.cancel,0)){
                cancel = '<a href=javascript:void(0); class="ui-link" style="color: gray;">取消</a>'
            }
            return `
                <div style="text-align:center;">
                    <a href=javascript:void(0); class="ui-link" data-type="view">查看</a>
                    <span> | </span>
                    ${cancel}
                <div>
            `;
        }},
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 }
    ],
    headerFor1: [
        { headerName: '操作', width: 100,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: false,minWidth: 50,cellRenderer: (param)=>{
            return `
                <div style="text-align:center;">
                    <a href=javascript:void(0); class="ui-link" data-type="view">查看</a>
                <div>
            `;
        }},
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
        { headerName: '完成时间', field: 'end_time',dinput_type:'5',width:150 }

    ],
    headerFor2: [
        { headerName: '操作', width: 200,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: false,minWidth: 50,
            cellRenderer: (param)=>{
                let data = param["data"];
                let html = '<div style="text-align:center;">' +
                    '<a href=javascript:void(0); class="ui-link" data-type="view">查看</a>' +
                    '<span> | </span>' +
                    '<a href=javascript:void(0); class="ui-link" data-type="cancel">删除</a> '
                if(data["edit_status"] == 0){
                    html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="urge">催办</a><span> | </span><a href=javascript:void(0); class="ui-link" data-type="withdraw">撤回</a>';
                }else if(data["edit_status"] == 1){
                    html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="edit">编辑</a>';
                }
                html += '</div>';
                return html;
            }
        },
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 }
    ],
    headerFor3: [
        { headerName: '操作', width: 120,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: false,minWidth: 50,cellRenderer: (param)=>{
            let data = param["data"];
            let html = `
            <div style="text-align:center;">
            <a href=javascript:void(0); class="ui-link" data-type="view">查看</a>`;
            if(data['status'] == '已完成') {
                html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="circulation">传阅</a>'
            }
            if( data.cancel_approve ){
                html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="drawApproval">撤回审批</a>'
            }
            html += '</div>';
            return html;
        }},
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 }
        // { headerName: '完成时间', field: 'end_time',dinput_type:'5',width:150 }

    ],
    headerFor4: [
        { headerName: '操作', width: 120,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: false,minWidth: 50,cellRenderer: (param)=>{
            let data = param["data"];
            let html = `
            <div style="text-align:center;">
            <a href=javascript:void(0); class="ui-link" data-type="view">查看</a>`;
            if( data.cancel_approve ){
                html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="drawApproval">撤回审批</a>'
            }
            html += '</div>';
            return html;
        }},
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 },
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
        // { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 }

    ],
    headerFor5: [
        { headerName: '操作', width: 170,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: true,minWidth: 50,
            cellRenderer: (param)=>{
                let data = param["data"];
                let html ='<div style="text-align:center;"><a href=javascript:void(0); class="ui-link" data-type="view">查看</a>';

                if(data["record_status"] == 0){
                    html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="suspend">暂缓</a>';
                }else if(data["record_status"] == 4){
                    html += '<span> | </span><a class="ui-link" style="color:#aaa;cursor: not-allowed">暂缓</a>';
                }
                html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="approve">审批</a></div>';
                return html;
            }},
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 },
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
    ],
    headerFor6: [
        { headerName: '操作', width: 120,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: false,minWidth: 50,
            cellRenderer: (param)=>{
                return `
                <div style="text-align:center;">
                <a href=javascript:void(0); class="ui-link" data-type="view">查看</a>
                <!--<span> | </span>-->
                <!--<a href=javascript:void(0); class="ui-link" data-type="approve">审批</a>-->
                <div>
            `;
            }},
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 }

    ],
    headerFor7: [
        { headerName: '操作', width: 120,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: true,minWidth: 50,
            cellRenderer: (param)=>{
                return `
                <div style="text-align:center;">
                <a href=javascript:void(0); class="ui-link" data-type="view">查看</a>
                <span> | </span>
                <a href=javascript:void(0); class="ui-link" data-type="approve">审批</a>
                <div>
            `;
            }},
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 },
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
    ],
    headerFor8: [
        { headerName: '操作', width: 160,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: false,minWidth: 50,
            cellRenderer: (param)=>{
                let data = param["data"];
                if(data['status'] == '已完成' || data['status'] == '取消') {
                    let html = `<div style="text-align:center;"><a href=javascript:void(0); class="ui-link" data-type="view">查看</a>`;
                    if(data['status'] == '已完成') {
                        html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="circulation">传阅</a>';
                    }
                    if( data.cancel_approve ){
                        html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="drawApproval">撤回审批</a>'
                    }
                    html += '</div>';
                    return html;
                }
                else {
                    let html = '<div style="text-align:center;">' +
                        '<a href=javascript:void(0); class="ui-link" data-type="view">查看</a>' +
                        '<span> | </span>' +
                        '<a href=javascript:void(0); class="ui-link" data-type="cancel">取消</a> '
                    if (data["record_status"] == 0 && data["edit_status"] == 0) {
                        html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="urge">催办</a><span> | </span><a href=javascript:void(0); class="ui-link" data-type="withdraw">撤回</a>';
                    } else if (data["edit_status"] == 1) {
                        html += '<span> | </span><a href=javascript:void(0); class="ui-link" data-type="edit">编辑</a>';
                    }
                    html += '</div>';
                    return html;
                }
            }},
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 },
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
    ],
    headerFor9: [
        { headerName: '操作', width: 170,field:'myOperate', suppressSorting: true,suppressMenu: true,suppressResize: true,minWidth: 50,
            cellRenderer: (param)=>{
                let html ='<div style="text-align:center;"><a href=javascript:void(0); class="ui-link" data-type="view">查看</a><span> | </span><a href=javascript:void(0); class="ui-link" data-type="urge">催办</a><span> ';
                return html;
            }},
        { headerName: '最后审批时间', field: 'last_handler_time',dinput_type:'5',width:150 },
        { headerName: '所属流程名称', field: 'flow_name',width:100 },
        { headerName: '工作名称', field: 'name',width:100 },
        { headerName: '关键字', field: 'keyword',width:100 },
        { headerName: '发起人', field: 'start_handler',width:100 },
        { headerName: '创建时间', field: 'create_time',dinput_type:'5',width:150 },
        { headerName: '当前状态', field: 'status',width:100 },
        { headerName: '当前节点', field: 'current_node',width:100 },
    ],
};


// WEBPACK FOOTER //
// app/services/dataGrid/workflow-config-header.service.js